export default "__VITE_ASSET__Cx$sxHGE__"